import { createContext, useContext } from 'react';
import { useMessaging } from '../hooks/messaging.js';

type WidgetContextType = {
    getToken: () => Promise<string | null>;
    activeWidget: { id: string | null; seq: number };
    mode: 'standalone' | 'embedded';
};

const WidgetContext = createContext<WidgetContextType | null>(null);

export function WidgetProvider({ children }: { children: React.ReactNode }) {
    const messaging = useMessaging();

    return <WidgetContext.Provider value={messaging}>{children}</WidgetContext.Provider>;
}

export function useWidget() {
    const context = useContext(WidgetContext);
    if (!context) {
        throw new Error('useWidget must be used within WidgetProvider');
    }
    return context;
}
